import { useState } from 'react';
import classNames from 'classnames';

export function useUiField(
  {
    renderIcons = () => [],
    hasIcons,
    fieldClassName,
    className,
    onBlur,
    onFocus,
    value,
    errorMessage,
    required = false,
    hideAsterisk = false,
    hideHelp = false,
    ...rest
  },
  config = { isTextarea: false }
) {
  const [hasFocus, setHasFocus] = useState(false);

  const icons = renderIcons();
  let iconsPosition = false;
  if (icons.length > 0) {
    if (icons.length === 2) {
      iconsPosition = true;
    } else {
      iconsPosition = hasIcons;
    }
  }
  const hasError = errorMessage ? 'danger' : '';
  const fieldClassNames = classNames('has-floating-label', fieldClassName);
  const labelClassNames = classNames({
    'is-active': config.isTextarea || hasFocus || !!value,
    'has-icons': !!iconsPosition && iconsPosition !== 'right',
    'is-focused': hasFocus,
  });
  const inputClassNames = classNames(
    config.isTextarea ? 'textarea' : 'input',
    {
      'is-danger': hasError,
      'is-active': config.isTextarea && hasFocus,
    },
    className
  );
  const composedOnBlur = composedFunction(() => setHasFocus(false), onBlur);
  const composedOnFocus = composedFunction(() => setHasFocus(true), onFocus);
  const showAsterisk = required && !hideAsterisk;

  const uiFieldProps = {
    icons,
    iconsPosition,
    hasError,
    fieldClassNames,
    labelClassNames,
    errorMessage,
    label: rest.label,
    showAsterisk,
    hideHelp,
  };
  const inputProps = {
    ...rest,
    value,
    className: inputClassNames,
    onBlur: composedOnBlur,
    onFocus: composedOnFocus,
    required,
  };

  return [uiFieldProps, inputProps];
}

export function composedFunction(...fns) {
  return function composed(...args) {
    fns.forEach(fn => fn(...args));
  };
}
